import {Dialog} from "@mui/material";
import React from "react";
import {TwoButtonDialog} from "../../../../../../designSystem/components/TwoButtonDialog";

interface LogoutDialogProps {
  isShow: boolean;
  onClickDontLogout: () => void;
  onClickLogout: () => void;
}

const LogoutDialog = ({
  isShow,
  onClickDontLogout,
  onClickLogout
}: LogoutDialogProps) => (
  <Dialog
    open={isShow}
    PaperProps={{sx: { borderRadius: 6 }}}
  >
    {isShow ?
      <TwoButtonDialog
        type="warning"
        title="你確定要登出嗎?"
        leftLabel="先不要"
        leftOnClick={onClickDontLogout}
        leftIconName="fa-circle-xmark"
        leftColor="secondary"
        rightLabel="登出"
        rightOnClick={onClickLogout}
        rightIconName="fa-power-off"
      />
      : null
    }
  </Dialog>
)

export default LogoutDialog;